export const servicesTableColumns: Record<string, boolean> = {
  risks: false,
  invoice: false,
  displayId: false,
  orderId: false,
  account: true,
  agent: true,
  location: true,
  progress: true,
  contact: true,
  eta: true,
  distance: true,
  serviceAreas: false,
  timeWindow: true,
  urgency: false,
  load: true,
  price: true,
  created: false,
  programType: false,
  timeToDeliver: false,
  cancellationReason: false,
  proNumber: false,
  taskApprovalStatus: false,
  itemsIds: false,
  itemsTypes: false,
  itemsBarcodes: false,
  notes: false,
  resource: false,
  referenceIds: false,
  operationalUnits: false
};
